import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $patchStyleText } from "@lexical/selection";
import { IconButton, Tooltip } from "@mui/material";
import { $getSelection, $isRangeSelection } from "lexical";
import { type FC, useCallback, useRef } from "react";

import { useTranslation } from "react-i18next";
import { FormatTextColour } from "../../../../../styles/icons/format-text-colour";
import { usePopover } from "../../../../../utils/hooks/use-popover";
import { ColourPicker } from "../../../../generic/components/colour-picker/colour-picker";
import { floatingToolbarStyles } from "./floating-toolbar-styles";
import type { ToolbarProps } from "./props";

// export function FontColourSelect({
//   disabled = false,
//   colour,
// }: {
//   disabled?: boolean;
//   colour: string;
// }): React.JSX.Element {
export const FontColourSelect: FC<ToolbarProps & { colour: string }> = ({
  disabled,
  colour,
  mode,
}) => {
  const { t } = useTranslation();
  const [editor] = useLexicalComposerContext();
  const popover = usePopover<HTMLButtonElement>();
  const popoverInputRef = useRef<HTMLInputElement>(null);

  const handleChange = useCallback(
    (newColour?: string) => {
      const restoreFocus = document.activeElement === popoverInputRef.current;

      editor.update(
        () => {
          const selection = $getSelection();
          if ($isRangeSelection(selection))
            $patchStyleText(selection, { color: newColour ?? null });
        },
        {
          onUpdate: () => {
            if (restoreFocus) popoverInputRef.current?.focus();
          },
        },
      );
    },
    [editor, popoverInputRef],
  );

  return (
    <>
      <Tooltip title={t("Font Color")}>
        <span>
          <IconButton
            data-analytics-id="lexical-toolbar-font-color"
            disabled={disabled}
            data-testid="toolbar-button-font-color"
            aria-label="Font Color"
            tabIndex={-1}
            sx={{
              ...floatingToolbarStyles[mode].button,
              backgroundColor: "background.neutral",
            }}
            // eslint-disable-next-line react-hooks/refs
            onClick={popover.handleToggle}
            // eslint-disable-next-line react-hooks/refs
            ref={popover.anchorRef}
          >
            <FormatTextColour textColour={colour} sx={floatingToolbarStyles[mode].formatIcon} />
          </IconButton>
        </span>
      </Tooltip>
      <ColourPicker
        // eslint-disable-next-line react-hooks/refs
        popover={popover}
        colour={colour}
        onInput={handleChange}
        onChange={handleChange}
        inputRef={popoverInputRef}
      />
    </>
  );
};
